import { Params } from '@angular/router';
import { DataPlatformCreditType } from './data-platform.model';
import {
  PROFILES_FILTER_URL_OPTIONS,
  VISITS_FILTER_URL_OPTIONS,
  encodeFilterUrlState,
  toDateParam,
} from './filter-url.utils';

export const VISITS_PAGE_URL = '/insights/visits';
export const PROFILES_PAGE_URL = '/profiles';

export const CONSENTED_PROFILES_PARAMS: Params = encodeFilterUrlState(
  { filter: { identifiedStatus: 'identified', consentFilter: 'has_consent' } },
  PROFILES_FILTER_URL_OPTIONS,
);

/** The Visits page looks the session up in the days around `after`, or in the last month without it. */
export function sessionVisitUrl(sessionId: number | string, after: readonly (Date | string)[] = []): string {
  const params = new URLSearchParams({ sessionid: String(sessionId) });
  const times = after.map((time) => new Date(time).getTime()).filter((time) => !Number.isNaN(time));
  if (times.length) {
    // The visit started up to a day before the first of them.
    const from = new Date(Math.min(...times));
    from.setDate(from.getDate() - 1);
    params.set('from', toDateParam(from));
    params.set('to', toDateParam(new Date(Math.max(...times))));
  }
  return `${VISITS_PAGE_URL}?${params}`;
}

/** `from` and `to` as `YYYY-MM-DD`. */
export function creditedVisitsParams(
  widgetIds: readonly number[],
  creditType: DataPlatformCreditType,
  from: string,
  to: string,
): Params {
  return encodeFilterUrlState(
    { filter: { widgetIds: [...widgetIds], widgetEventTypes: [creditType] }, from, to },
    { ...VISITS_FILTER_URL_OPTIONS, includeDates: true },
  );
}
